import React from 'react';
import { View } from 'react-native';

import Chip from './Chip';
import { useManageChipGroup } from './hooks/useManageChipGroup';
import type { ChipGroupProps } from '@components/tenantStatus/onboardingWizard/types';

const ChipGroup = ({ C, options, selected, multiSelect, onChange, testIDPrefix }: ChipGroupProps) => {
  const { handlePress } = useManageChipGroup({ selected, multiSelect, onChange });

  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
      {options.map((option) => (
        <Chip
          key={option}
          C={C}
          label={option}
          selected={selected.includes(option)}
          onPress={() => handlePress(option)}
          testID={testIDPrefix ? `${testIDPrefix}-${option}` : undefined}
        />
      ))}
    </View>
  );
};

export default ChipGroup;
